import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/to-dos';


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryToDosWidgetSuccess as MemberDetailsCommunicationHistoryToDosWidgetSuccess } from 'ui/views/widgets/memberDetailsCommunicationHistoryToDosWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryToDosWidgetSuccess propName='propValue'/>
 */
const memberDetailsCommunicationHistoryToDosWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-communication-history-to-dos-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryToDosWidgetSuccess.displayName = 'memberDetailsCommunicationHistoryToDosWidget';

// set default props
memberDetailsCommunicationHistoryToDosWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsCommunicationHistoryToDosWidgetSuccess.propTypes = {};

// ***********************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsCommunicationHistoryToDosWidgetPreloader as MemberDetailsCommunicationHistoryToDosWidgetPreloader } from 'ui/views/widgets/memberDetailsCommunicationHistoryToDosWidget';
 *
 * // render
 * <memberDetailsCommunicationHistoryToDosWidgetPreloader propName='propValue'/>
 */
const memberDetailsCommunicationHistoryToDosWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-communication-history-to-dos-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-communication-history-to-dos-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryToDosWidgetPreloader.displayName = 'memberDetailsCommunicationHistoryToDosWidgetPreloader';

// set default props
memberDetailsCommunicationHistoryToDosWidgetPreloader.defaultProps = {};

// prop types
memberDetailsCommunicationHistoryToDosWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryToDosWidget as MemberDetailsCommunicationHistoryToDosWidget } from 'ui/views/widgets/memberDetailsCommunicationHistoryToDosWidget';
 *
 * // render
 * <memberDetailsCommunicationHistoryToDosWidget propName='propValue'/>
 */
export const memberDetailsCommunicationHistoryToDosWidget = withNetworkState( memberDetailsCommunicationHistoryToDosWidgetPreloader, memberDetailsCommunicationHistoryToDosWidgetSuccess );

